import { convertDateToString } from 'features/assetDatabase/components/assetTable/AssetTableHelpers'
import React from 'react'
import { renderToString } from 'react-dom/server'
import { CrewDetailsJSON } from 'types'

import { AddedToJobEmail } from './crewNotificationEmailTemplates/AddedToJobEmail'
import { JobAssignmentChangedEmail } from './crewNotificationEmailTemplates/JobAssignmentChangedEmail'

export const getCrewMemberAddedEmail = (
  crewMember: CrewDetailsJSON,
  shift: 'day' | 'night',
  currentUser: string,
  siteName: string,
  siteAddress: string
) => {
  return {
    email: crewMember.email,
    subject: `${currentUser} has added you on a job assignment at ${siteName} starting ${convertDateToString(crewMember.start_date)}`,
    htmlContent: renderToString(
      <AddedToJobEmail
        currentUser={currentUser ?? ''}
        url={window.location.href}
        role={crewMember.role}
        startDate={convertDateToString(crewMember.start_date) ?? ''}
        endDate={convertDateToString(crewMember.end_date) ?? ''}
        siteName={siteName ?? ''}
        shift={shift}
      />
    ),
    calendarData: getCrewMemberAssignmentCalendarData(
      crewMember,
      siteName,
      siteAddress
    ),
  }
}

export const getCrewMemberAssignmentChangedEmail = (
  crewMember: CrewDetailsJSON,
  shift: 'day' | 'night',
  currentUser: string,
  siteName: string,
  siteAddress: string
) => {
  return {
    email: crewMember.email,
    subject: `${currentUser} has changed your job assignment at ${siteName}`,
    htmlContent: renderToString(
      <JobAssignmentChangedEmail
        currentUser={currentUser ?? ''}
        url={window.location.href}
        role={crewMember.role}
        startDate={convertDateToString(crewMember.start_date) ?? ''}
        endDate={convertDateToString(crewMember.end_date) ?? ''}
        siteName={siteName ?? ''}
        shift={shift}
      />
    ),
    calendarData: getCrewMemberAssignmentCalendarData(
      crewMember,
      siteName,
      siteAddress
    ),
  }
}

export const getCrewMemberAssignmentCalendarData = (
  crewMember: CrewDetailsJSON,
  siteName: string,
  siteAddress: string
) => {
  return {
    start_date: crewMember.start_date.toISOString(),
    end_date: crewMember.end_date.toISOString(),
    description: `Created on ${convertDateToString(new Date())}`,
    name: `Job at ${siteName}`,
    location: siteAddress,
  }
}
